import React from "react";
import Order_list from "./component-order-list";
import Total_action from "./component-total-action";
import { useCartStore } from "../../store/useCartStore";

function Mini_cart(){

    const cart = useCartStore((state) => state.cart);

    return(
        <div id="mini-cart" className={(cart.length > 0) ? 'd-block' :'d-none'}>
            <Order_list />
            <Total_action />
        </div>
    );

}

export default Mini_cart;